import React, { createContext, useContext } from 'react';
type Props = {
  children: ReactNode;
  pageContext: PageContext;
};
const INITIAL_CONTEXT = {};
export const ReactPageContext = createContext<PageContext>(INITIAL_CONTEXT);
export const PageContextProvider = ({ children, pageContext }: Props) => {
  return <ReactPageContext.Provider value={pageContext}>{children}</ReactPageContext.Provider>;
};
export const usePageContext = (): PageContext => {
  const context = useContext<PageContext>(ReactPageContext);

  if (context === INITIAL_CONTEXT) {
    throw new Error('usePageContext must be used within a ReactPageContext.Provider');
  }

  return context;
};
